import { ReactTitle } from "react-meta-tags";
import ReactDatePicker from "react-datepicker";
import Modal from "../../../utils/customModal";
import React, { useState, useEffect } from "react";
import Checkbox from "../../../shared/custom-components/checkbox";
import { instanceAction } from "../../../../Redux/api";
import { useDispatch, useSelector } from "react-redux";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import {
  getClientWaivers,
  clearWaivers,
} from "../../../../Redux/actions/clientActions";
import {
  errorContainer,
  formatDashDate,
  loadingHtml,
  sucessInfoModal,
} from "../../../utils/functions";
import {
  getWaivers,
  getInstitutionsProfile,
} from "../../../../Redux/reducer/clients";
import { useTranslation } from "react-i18next";

const capitalizeWord = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const Waivers = () => {
  const [edited, setEdited] = useState(false);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});

  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });

  const waivers = useSelector((state) => getWaivers(state));
  const institution = useSelector((state) => getInstitutionsProfile(state));

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (waivers.length > 0) {
      const tmpSelected = { ...selected };
      waivers.map(({ key, value }) => {
        if (value) tmpSelected[key] = new Date(value);
      });

      setSelected({ ...tmpSelected });
    } else {
      setModal({ show: true, content: loadingHtml(), onClose: undefined });
      dispatch(getClientWaivers(institution.company.id))
        .then(() => {
          closeModal();
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            var content = errorContainer(
              notification.message,
              notification.description
            );

            setModal({ show: true, content, onClose: () => closeModal() });
          }
        });
    }
  }, [waivers]);

  useEffect(() => {
    return () => {
      dispatch(clearWaivers());
    };
  }, []);

  const handleCancel = () => {
    setSelected(
      waivers.reduce((acc, { key, value }) => {
        if (value) acc[key] = new Date(value);
        return acc;
      }, {})
    );

    setEdited(false);
  };

  const handleEdit = () => !edited && setEdited(true);

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const handlerChange = ({ target: { name, checked } }) => {
    handleEdit();
    if (checked) setSelected({ ...selected, [name]: null });
    else {
      // eslint-disable-next-line no-unused-vars
      const { [name]: key, ...restSelected } = selected;
      setSelected({ ...restSelected });
    }
  };

  const onChangeDate = (date, key) => {
    handleEdit();
    setSelected((prev) => ({ ...prev, [key]: date }));

    if (errors[key] !== undefined) {
      const tmpErr = { ...errors };
      delete tmpErr[key];
      setErrors(tmpErr);
    }
  };

  const valid = () => {
    const tmpErrors = { ...errors };
    Object.keys(selected).map((key) => {
      if (!selected[key]) tmpErrors[key] = true;
      return true;
    });

    setErrors(tmpErrors);
    return Object.keys(tmpErrors).length > 0;
  };

  const details = (detail) => {
    const item = waivers.find((item) => item.key === detail.key);

    return (
      <div key={`result-${detail.key}`}>
        <p className="result">{item.title}</p>
        <p className="detail-message"> - {detail.message}</p>
      </div>
    );
  };

  const onSumbit = () => {
    if (valid() > 0) return;

    const data = waivers.flatMap(({ key, value }) => {
      if (selected[key])
        return {
          [key]: formatDashDate(selected[key]),
          [`check${capitalizeWord(key)}`]: true,
        };

      return value
        ? {
            [key]: formatDashDate(value),
            [`check${capitalizeWord(key)}`]: false,
          }
        : [];
    });

    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    dispatch(
      instanceAction(
        `/companies/waiver/${institution.company.id}`,
        "post",
        data
      )
    )
      .then((response) => {
        const data = response.data.data;

        var message = (
          <>
            <p className="subtitle">{t("general.waiver.titleResult")}:</p>
            {data.details.map((detail) => details(detail))}
          </>
        );

        var content = sucessInfoModal("Waiver", message, {
          formBtn: {
            action: closeModal,
            text: t("general.buttons.close"),
          },
        });

        setModal({ show: true, content, onClose: () => closeModal() });
        setEdited(false);
      })
      .catch((err) => {
        const notification = err.response.data.notifications[0];

        var content = errorContainer(
          notification.message,
          notification.description
        );
        setModal({ show: true, content, onClose: () => closeModal() });
      });
  };

  return (
    <>
      <ReactTitle title={`Gestión de Clientes - Waivers`} />
      <div className="clearfix service-container">
        <div key={`module-header`} className="loaded-module waivers">
          <h2 className="flex-element">Información</h2>
          <h2>Fecha</h2>
        </div>
        {waivers.map(({ title, key }) => (
          <div key={`option-${key}`} className="loaded-module waivers">
            <Checkbox
              key={`chk-${key}`}
              id={`chk-${key}`}
              name={key}
              label={title}
              checked={selected[key] !== undefined}
              onChange={handlerChange}
              className="changes"
            />
            <ReactDatePicker
              id={key}
              name={key}
              className={`datepicker-input
     ${selected[key] === undefined ? " disable" : ""}
     ${errors[key] === true ? " input-error" : ""}
     `}
              onChange={(date) => onChangeDate(date, key)}
              showMonthDropdown
              showYearDropdown
              showPopperArrow={false}
              dropdownMode="scroll"
              selected={selected[key] || null}
              readOnly={selected[key] === undefined}
            />
          </div>
        ))}
        <div className="form-actions clearfix">
          <SecondaryButton
            id={`cancel-btn`}
            className="btnLimpiar"
            onClick={handleCancel}
            disabled={!edited}
          >
            {t("general.buttons.cancel")}
          </SecondaryButton>
          <SecondaryButton
            id={`process-btn`}
            className="btnAgregar"
            onClick={onSumbit}
            disabled={!edited}
          >
            {t("general.buttons.sendForApproval")}
          </SecondaryButton>
        </div>
      </div>
      <Modal
        key={`waivers-modal`}
        show={modal.show}
        handleClose={modal.onClose}
      >
        {modal.content}
      </Modal>
    </>
  );
};

export default Waivers;
